<template>
  <div class="titbox">
    <div style="display: flex; align-items: center;margin:10px 0px;">
      <el-autocomplete
        v-model="officialAccount"
        :fetch-suggestions="querySearchAsync"
        placeholder="请输入公众号"
        @select="handleSelect"
      />
    </div>

    <div class="line" />
    <div class="keyindicators">
      <div class="ketitembox">
        <div
          style="margin-right: 15px;display: flex;flex-direction: column;"
        >
          <span class="addtext">昨日已支付金额(元)</span>
          <span class="addnum">{{ keyindicators.yesterday ? keyindicators.yesterday.totalPaidAmount : '请选择公众号' }}</span>
        </div>
        <div style="display: flex;flex-direction: column;">
          <span class="addtext">今日已支付金额(元)</span>
          <span class="addnum">{{ keyindicators.today ? keyindicators.today.totalPaidAmount : '请选择公众号' }}</span>
        </div>
      </div>
      <div class="ketitembox">
        <div style="margin-right: 15px;display: flex;flex-direction: column;">
          <span class="addtext">昨日未支付金额(元)</span>
          <span class="addnum">{{ keyindicators.yesterday ? keyindicators.yesterday.totalUnpaidAmount : '请选择公众号' }}</span>
        </div>
        <div style="display: flex;flex-direction: column;">
          <span class="addtext">今日未支付金额(元)</span>
          <span class="addnum">{{ keyindicators.today ? keyindicators.today.totalUnpaidAmount : '请选择公众号' }}</span>
        </div>
      </div>
      <div class="ketitembox">
        <div style="margin-right: 15px;display: flex;flex-direction: column;">
          <div class="addtext">昨日已支付订单数</div>
          <div class="addnum">{{ keyindicators.yesterday ? keyindicators.yesterday.countPaid : '请选择公众号' }}</div>
        </div>
        <div style="display: flex;flex-direction: column;">
          <div class="addtext">今日已支付订单数</div>
          <div class="addnum">{{ keyindicators.today ? keyindicators.today.countPaid : '请选择公众号' }}</div>
        </div>
      </div>
      <div class="ketitembox">
        <div style="margin-right: 15px;display: flex;flex-direction: column;">
          <div class="addtext">昨日未支付订单数</div>
          <div class="addnum">{{ keyindicators.yesterday ? keyindicators.yesterday.countUnpaid : '请选择公众号' }}</div>
        </div>
        <div style="display: flex;flex-direction: column;">
          <div class="addtext">今日未支付订单数</div>
          <div class="addnum">{{ keyindicators.today ? keyindicators.today.countUnpaid : '请选择公众号' }}</div>
        </div>
      </div>

      <div class="ketitembox">
        <div style="margin-right: 15px;display: flex;flex-direction: column;">
          <div class="addtext">已支付总订单数</div>
          <div class="addnum">{{ keyindicators.totalAll ? keyindicators.totalAll.paid[0].num : '请选择公众号' }}</div>
        </div>
        <div style="display: flex;flex-direction: column;">
          <div class="addtext">未支付总订单数</div>
          <div class="addnum">{{ keyindicators.totalAll ? keyindicators.totalAll.unpaid[0].num : '请选择公众号' }}</div>
        </div>
      </div>
      <div class="ketitembox">
        <div style="margin-right: 15px;display: flex;flex-direction: column;">
          <div class="addtext">已支付总金额</div>
          <div class="addnum">{{ keyindicators.totalAll ? keyindicators.totalAll.paid[0].amount : '请选择公众号' }}</div>
        </div>
        <div style="display: flex;flex-direction: column;">
          <div class="addtext">未支付总金额</div>
          <div class="addnum">{{ keyindicators.totalAll ? keyindicators.totalAll.unpaid[0].amount : '请选择公众号' }}</div>
        </div>
      </div>
    </div>
    <div class="line-linr" />
    <div class="selectbtn">
      <el-date-picker
        v-model="times"
        style="margin-left:10px;"
        type="daterange"
        range-separator="至"
        start-placeholder="开始日期"
        end-placeholder="结束日期"
        :picker-options="{
          disabledDate(time) { // 设置禁用状态，参数为当前日期，要求返回 Boolean
            return time.getTime() > Date.now();
          }
        }"
        :default-value="new Date().setMonth(new Date().getMonth() - 1)"
      />
      <!-- <el-select v-model="officialType" placeholder="请选择类型" style="margin-left:10px;">
        <el-option
          v-for="item in keyindicators.source ? Object.keys(keyindicators.source).map((item)=>{
            return {
              id: item,
              value: keyindicators.source[item]
            }
          }) : []"
          :key="item.id"
          :label="item.value"
          :value="item.value"
        />
      </el-select> -->
      <el-button type="success" style="margin-left:20px;" @click="query">查询</el-button>
    </div>
    <div id="main3" class="echarts" style="width:80vw;" />
    <el-table
      :data="tableData.slice((pase-1)*10, pase*10)"
      border
      style="width: 100%;margin-top:10px"
    >
      <el-table-column
        prop="time"
        label="时间"
        width="180"
      />
      <el-table-column
        v-if="!money.includes('已支付金额')"
        prop="paidAmount"
        label="已支付金额(元)"
        width="180"
      />
      <el-table-column
        v-if="!money.includes('已支付订单数')"
        prop="paidCount"
        label="已支付订单数"
      />
      <el-table-column
        v-if="!money.includes('未支付金额')"
        prop="unpaidAmount"
        label="未支付金额(元)"
      />
      <el-table-column
        v-if="!money.includes('未支付订单数')"
        prop="unpaidCount"
        label="未支付订单数"
      />
    </el-table>
    <PaginationRight
      :total="tableData.length"
      @size-change="fetchPageSize"
      @current-change="fetchCurrentPage"
    />
  </div>
</template>

<script>
import * as echarts from 'echarts'
import { orderStatistics, officialAccountSearchDisplay, orderIconStatistics } from '@/api/effectData.js'
import PaginationRight from '@/components/PaginationRight/index.vue'
import convertToHump from '@/utils/mixins/convertToHump.js'
export default {
  components: {
    PaginationRight
  },
  mixins: [convertToHump],
  data() {
    return {
      money: [],
      myChart: '',
      tableData: [],
      series: [],
      officialAccount: this.$route.query.appId, // 公众号
      keyindicators: {}, // 存储根据公众号获取的数据
      officialType: '', // 选择公众号枚举值
      times: [], // 时间
      pase: 1, // 当前页
      allappid: null
    }
  },
  async created() {
    const data = await officialAccountSearchDisplay({
      appId: this.$route.query.appId
    })
    // data.data.list = data.data.list
    this.officialAccount = data.data.list[0].account_name
    // this.officialAccount = data.data.list.filter(item => item.app_id === this.$route.query.appId)[0].account_name
  },
  mounted() {
    this.localEchart()
    this.chartResize(this.myChart)
    this.myChart.on('legendselectchanged', (params) => {
      if (params.selected[params.name]) { // 去除
        this.money = this.money.filter(item => item !== params.name)
      } else if (!params.selected[params.name]) { // 添加
        this.money.push(params.name)
      }
    })
    this.handleSelect({ app_id: this.officialAccount })
  },
  methods: {
    localEchart(legend = [], tiems = []) {
      const chartDom = document.getElementById('main3')
      this.myChart = echarts.init(chartDom)
      var option
      option = {
        tooltip: {
          trigger: 'axis'
        },
        legend: {
          data: legend
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '3%',
          containLabel: true
        },
        xAxis: {
          type: 'category',
          data: tiems
        },
        yAxis: {
          type: 'value'
        },
        series: this.series
      }
      option && this.myChart.setOption(option, true)
    },
    chartResize(chart) {
      window.addEventListener('resize', () => {
        chart.resize()
      })
    },
    async querySearchAsync(queryString, cb) {
      const data = await officialAccountSearchDisplay({ account_name: queryString })
      const list = data.data.list
      list.forEach((item) => {
        item.value = item.account_name
        item.address = item.app_id
      })
      cb(list)
    },
    async handleSelect(item) {
      console.log('item', item.app_id)
      this.allappid = item.app_id
      const data = await orderStatistics({ appId: item.app_id })
      this.keyindicators = data.data
      this.empty()
      await this.query()
      // this.localEchart()
    },
    async query() {
      const data = {
        appId: this.allappid,
        beginTime: this.times ? this.times[0].toLocaleDateString().split('/').join('-') : null,
        endTime: this.times ? this.times[1].toLocaleDateString().split('/').join('-') : null,
        source: this.officialType ? this.officialType : undefined
      }
      if (this.verification(data)) {
        const data1 = await orderIconStatistics(data)
        const arr = this.conversionSplicing(data1.data)
        this.series = arr
        this.tableData = data1.data
        this.localEchart(this.series.map(item => item.name), data1.data.map(item => item.time))
      }
    },

    // 数据校验
    verification(data) {
      if (!data.appId || !data.beginTime || !data.endTime) {
        this.$message({
          message: data.appId ? '请选择日期' : '请选择公众号',
          type: 'warning'
        })
        return false
      }
      return true
    },

    // 将数据进行转换成图标所需的数据
    conversionSplicing(data) {
      const obj = {
        paidAmount: [],
        paidCount: [],
        unpaidAmount: [],
        unpaidCount: []
      }
      const arr = []
      data.forEach((item) => {
        typeof (item.paidAmount) === 'number' && obj.paidAmount.push(item.paidAmount)
        typeof (item.paidCount) === 'number' && obj.paidCount.push(item.paidCount)
        typeof (item.unpaidAmount) === 'number' && obj.unpaidAmount.push(item.unpaidAmount)
        typeof (item.unpaidCount) === 'number' && obj.unpaidCount.push(item.unpaidCount)
      })
      const names = { time: '时间', paidAmount: '已支付金额', paidCount: '已支付订单数', unpaidAmount: '未支付金额', unpaidCount: '未支付订单数' }
      for (const key in obj) {
        if (obj[key].length) {
          arr.push({
            name: names[key],
            type: 'line',
            stack: 'Total',
            data: obj[key]
          })
        }
      }

      return arr
    },

    fetchPageSize(value) {
      console.log(value)
    },

    fetchCurrentPage(value) {
      this.pase = value
    },

    // 重置数据
    empty() {
      this.officialType = ''
      this.times = [new Date(new Date().getTime() - 72 * 60 * 60 * 1000), new Date(new Date().getTime() - 24 * 60 * 60 * 1000)]
      this.series = []
      this.money = []
      this.pase = 1
      this.tableData = []
    }
  }
}
</script>
<style scoped>
.titbox{
/*   padding: 20px 20px 0px 20px; */
}
.title{
  color: aqua;
  font-size: 20px;
  margin-bottom: 10px;
}
.line{
  width: 100%;
  height: 1px;
  background: #ccc;
}
.keyindicators{
  display: flex;
  justify-content: space-around;
  padding-top: 20px;
  box-sizing: border-box;
}
.ketitembox{
  text-align: center;
  position: relative;
  display: flex;
  width: 16.6%;
  justify-content: center;
}
.ketitembox::after{
  content: '';
  height: 40px;
  width: 2px;
  background: rgb(35, 139, 224);
  position: absolute;
  right: 0px;
  top: 10px;
}
.ketitembox:last-child::after{
  content: '';
  height: 0px;
  width: 0px;
}
.addtext{
  color: black;
  font-size: 13px;
}
.addnum{
  color: red;
  font-size: 12px;
  margin-top: 15px;
}
.line-linr{
  height: 20px;
  width: 100%;
  background: #ccc;
  margin-top: 20px;
}
.selectbtn{
  display: flex;
  margin-top: 8px;
  margin-bottom: 8px;
}
.select_btnr{
  padding: 10px;
  box-sizing: border-box;
  border: 1px solid #ccc;
  border-radius: 8px;
  margin-right: 5px;
  color: aquamarine;
}
.active{
  background: pink;
  color: white;
}
.echarts {
  width: 90vw;
  height: 400px;
}
.choosedata{
  display: flex;
  align-items: center;
      }
      .seleadatra{
        margin-right: 10px;
      }

      #app{
            width: 900px;
            background-color: rgb(241, 241, 241);
            margin: 50px auto;
            display: flex;
        }

        .delect{
            position: absolute;
            right: 0;
            top: 0;
             width: 20px;
             height: 20px;
             text-align: center;
             line-height: 20px;
             font-size: 15px;
             background-color: rgba(255, 255, 255,0.5);
             user-select: none;
             cursor: pointer;
             /* opacity: 0; */
        }

        .upload{
            width: 80px;
            height: 20px;
            background-color: rgba(135, 206, 235,0.2);
            border: 1px dashed black;
            border-radius: 5px;
            position: relative;

        }
        .upload:hover{
            background-color: rgba(135, 206, 235,1);
        }
        .upload::before{
            position: absolute;
            top: 0;
            left: 0;
            right: 0;
            bottom: 0;
            content: '上传图片';
            font-size: 13px;
            text-align: center;
            font-family: 'fangsong';
            line-height: 20px;
            user-select: none;
        }
        #file{
            width: 100%;
            height: 100%;
            opacity: 0;
        }

             .uploadSec{
          position: relative;
          display: inline-block;
          overflow: hidden;
             }
          #choose{
            position: absolute;
            height: 100%;
            left: 0;
            top: 0;
            opacity: 0;
          }
.updataboxr{
  position: relative;
}
</style>

